module.exports = __webpack_public_path__ + "media/application/images/ui/icon-email-3fca2a2993e45d55f9ec41f917e78863.png";